module.exports = __webpack_public_path__ + "media/frontend/base/typo/fonts/DejaVuSans-print-17bafec64028ec1632fd7bbf942fe8c2.ttf";